/* THE BALLOONWALA - Desktop UI (mobile-matching). Runs ONLY >=990px. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
  var WA_NUM = '919909902920';
  var TAG_CATS = {
    birthday: { label: 'Birthday', tags: ['Kids Birthday New', 'Kids Themed Birthday', 'Adult Birthday'] },
    romantic: { label: 'Romantic', tags: ['Romantic New'] },
    baby: { label: 'Baby Shower', tags: ['Baby Shower New'] },
    welcome: { label: 'Welcome Baby', tags: ['Welcome Baby'] },
    anniversary: { label: 'Anniversary', tags: ['Anniversary Decoration New'] },
    wedding: { label: 'Wedding', tags: ['Groom/Bride to be', 'Wedding'] },
    others: { label: 'Others', tags: ['Others'] },
    bouquet: { label: 'Balloon Bouquet', tags: ['Balloon Bouquet'] }
  };
  var BIRTHDAY_SUB = {
    all: { label: 'All Birthday', tags: [] },
    kids: { label: 'Kids Birthday', tags: ['Kids Birthday New'] },
    themed: { label: 'Themed Birthday', tags: ['Kids Themed Birthday'] },
    adult: { label: 'Adult Birthday', tags: ['Adult Birthday'] }
  };
  var TBW_CITIES = [
    { name: 'Bangalore', tag: 'From Rs.1,599' }, { name: 'Hyderabad', tag: 'Special pkg' },
    { name: 'Pune', tag: 'Special pkg' }, { name: 'Mumbai', tag: '' },
    { name: 'Surat', tag: '' }, { name: 'Delhi', tag: '' },
    { name: 'Ahmedabad', tag: '' }, { name: 'Kolkata', tag: '' },
    { name: 'Chennai', tag: '' }, { name: 'Raipur', tag: '' },
    { name: 'Gurgaon', tag: '' }, { name: 'Jaipur', tag: '' },
    { name: 'Chandigarh', tag: '' }, { name: 'Indore', tag: '' },
    { name: 'Lucknow', tag: '' },
    { name: 'Kanpur', tag: '' }
  ];
  var CITY_NOTICE_CITIES = ['Bangalore', 'Hyderabad', 'Pune', 'Surat'];
  var BOUQUET_CITIES = ['Bangalore', 'Mumbai', 'Pune']; /* Balloon Bouquets availability — Blr+Mum+Pune (Rishi 2026-11-03: Pune added back at launch) */
  var MORE_ITEMS = [
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>', lb: 'Login / My Account', sub: 'Orders, addresses', href: '/account' },
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9M5 9v11h14V9M9 20v-5h6v5"/></svg>', lb: 'Vendor Registration', sub: 'Join as a decorator', href: '/pages/join-us' },
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h6"/></svg>', lb: 'Blogs', sub: 'Tips & ideas', href: '/blogs/news' },
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>', lb: 'WhatsApp Us', sub: 'Chat with us', href: 'https://wa.me/' + WA_NUM + '?text=Hi!' },
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>', lb: 'Disclaimer', sub: 'Terms of service', href: '/pages/disclaimer' },
    { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>', lb: 'Privacy Policy', sub: 'How we use data', href: '/pages/privacy-policy' }
  ];

  /* 1. NAV INJECTION */
  function injectNav() {
    var menu = document.querySelector('.header__inline-menu .list-menu--inline');
    if (!menu || menu.querySelector('.tbw-nav-link')) return;
    var path = window.location.pathname;
    var navItems = [
      { label: 'Home', href: '/', active: path === '/' },
      { label: 'Explore', href: '/collections/all', active: path.indexOf('/collections') === 0 },
      { label: 'Cart', href: '/cart', active: path.indexOf('/cart') === 0 },
      { label: 'More', href: '/pages/tbw-more', active: path.indexOf('/pages/tbw-more') === 0 }
    ];
    navItems.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'list-menu__item--link tbw-nav-link' + (item.active ? ' tbw-nav-active' : '');
      a.href = item.href;
      a.textContent = item.label;
      menu.appendChild(a);
    });
    var icons = document.querySelector('.header__icons');
    if (icons && !document.querySelector('.tbw-city-pill')) {
      var city = localStorage.getItem('tbw_city') || 'Bangalore';
      var pill = document.createElement('div');
      pill.className = 'tbw-city-pill';
      pill.id = 'tbw-city-pill';
      pill.innerHTML = '\u{1F4CD} <span id="tbw-city-label">' + city + '</span>';
      pill.addEventListener('click', openCityGate);
      icons.insertBefore(pill, icons.firstChild);
    }
    /* Search bar — injected into header, before icons */
    var headerEl = document.querySelector('.header');
    var iconsEl = document.querySelector('.header__icons');
    if (headerEl && iconsEl && !document.querySelector('.tbw-search-wrap')) {
      var sw = document.createElement('div');
      sw.className = 'tbw-search-wrap';
      sw.innerHTML = '<svg class="tbw-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>' +
        '<input type="text" class="tbw-search-input" id="tbw-search-input" placeholder="Search designs & themes..." autocomplete="off">' +
        '<div class="tbw-search-results" id="tbw-search-results"></div>';
      headerEl.insertBefore(sw, iconsEl);
      initSearchInput();
    }
  }

  /* 2. CITY GATE MODAL */
  function buildCityGate() {
    if (document.getElementById('tbw-citygate')) return;
    var overlay = document.createElement('div');
    overlay.className = 'tbw-citygate-overlay';
    overlay.id = 'tbw-citygate';
    overlay.innerHTML = '<div class="tbw-citygate-box"><h3>\u{1F388} Choose your city</h3>' +
      '<p>We curate local pricing & availability per city. Pick yours to see setups available near you.</p>' +
      '<div class="tbw-citygate-grid" id="tbw-citygate-grid"></div></div>';
    overlay.addEventListener('click', function (e) { if (e.target === overlay && !cityGateForced) closeCityGate(); });
    document.body.appendChild(overlay);
    var grid = document.getElementById('tbw-citygate-grid');
    var cur = localStorage.getItem('tbw_city') || 'Bangalore';
    grid.innerHTML = TBW_CITIES.map(function (c) {
      return '<div class="tbw-citygate-opt' + (c.name === cur ? ' tbw-city-on' : '') + '" data-city="' + c.name + '">' +
        '<div class="cg-nm">' + c.name + '</div><div class="cg-tg">' + c.tag + '</div></div>';
    }).join('');
    grid.querySelectorAll('.tbw-citygate-opt').forEach(function (el) {
      el.addEventListener('click', function () { setCity(el.getAttribute('data-city')); });
    });
  }
  function openCityGate() { buildCityGate(); var g = document.getElementById('tbw-citygate'); if (g) g.classList.add('tbw-show'); }
  function closeCityGate() { var g = document.getElementById('tbw-citygate'); if (g) g.classList.remove('tbw-show'); }
  function setCity(city) {
    localStorage.setItem('tbw_city', city);
    if (cityGateForced) { cityGateForced = false; document.body.classList.remove('tbw-gate-forced'); }
    if (city === 'Chennai') setTimeout(openChennaiPinCheck, 350);
    var l = document.getElementById('tbw-city-label'); if (l) l.textContent = city;
    closeCityGate();
    var path = window.location.pathname;
    var citySlug = city.toLowerCase().replace(/\s+/g, '');
    /* If on a city-specific collection page (e.g. ...-in-mumbai), replace
       the city segment and navigate to the new city's page. */
    if (path.indexOf('-in-') > -1) {
      var newPath = path.replace(/-in-[a-z]+(?=\/|$)/i, '-in-' + citySlug);
      if (newPath !== path) { window.location.href = newPath; return; }
    }
    /* If on the generic birthday or all-products collection, go to city page */
    if (path === '/collections/birthday-balloon-decoration' || path === '/collections/all') {
      window.location.href = '/collections/birthday-balloon-decoration-services-in-' + citySlug;
      return;
    }
    if (typeof window.tbwApplyTagFilter === 'function') window.tbwApplyTagFilter();
  }
  /* Strict entrance guard (2026-10): first visit MUST pick a city -
     the gate cannot be dismissed by tapping outside, and the page
     behind it is blurred + inert until a city is chosen (matches the
     mobile app's forceOpenCity policy). */
  var cityGateForced = false;
  function maybeShowCityGate() {
    if (localStorage.getItem('tbw_city')) return;
    cityGateForced = true;
    document.body.classList.add('tbw-gate-forced');
    setTimeout(openCityGate, 350);
  }


  /* 3. CHENNAI PINCODE SERVICEABILITY (2026-10) - informational, never
     blocks browsing. Same localStorage key as the mobile app
     (tbw_pin_chennai) so a shared device keeps one answer. */
  var CHENNAI_PINS = ["600001","600002","600003","600004","600005","600006","600007","600008","600009","600010","600011","600012","600014","600016","600017","600018","600020","600021","600023","600024","600026","600028","600031","600032","600033","600034","600039","600040","600041","600042","600043","600061","600078","600079","600083","600086","600087","600088","600090","600094","600095","600097","600101","600102","600106","600108","600112"];
  function openChennaiPinCheck() {
    var old = document.getElementById('tbw-pincheck'); if (old) old.remove();
    var ov = document.createElement('div');
    ov.id = 'tbw-pincheck';
    ov.className = 'tbw-citygate-overlay tbw-show';
    var last = null;
    try { last = JSON.parse(localStorage.getItem('tbw_pin_chennai') || 'null'); } catch (e) {}
    var box = document.createElement('div');
    box.className = 'tbw-citygate-box';
    box.style.maxWidth = '340px';
    box.innerHTML =
      '<div style="font-size:30px">\uD83D\uDCCD</div>' +
      '<h3 style="margin:6px 0 4px">Check service in Chennai</h3>' +
      '<p style="color:#777;font-size:13px;margin:0 0 14px">Enter your pincode to check decoration service availability</p>' +
      '<input id="tbw-pin-in" type="text" inputmode="numeric" maxlength="6" placeholder="e.g. 600001" style="width:100%;box-sizing:border-box;border:1.5px solid #e5c9c4;border-radius:10px;padding:11px 12px;font-size:16px;text-align:center;letter-spacing:2px;outline:none" />' +
      '<div id="tbw-pin-msg" style="min-height:18px;margin:10px 0 4px;font-size:13px;line-height:1.45">' +
      (last ? (last.ok ? '\u2705 Last check: ' + last.pin + ' - serviceable' : 'Last check: ' + last.pin + ' - not serviceable yet') : '') +
      '</div>' +
      '<button id="tbw-pin-go" class="tbw-citygate-continue" style="width:100%;margin-top:6px">Check serviceability</button>' +
      '<div id="tbw-pin-close" role="button" style="margin-top:12px;font-size:13px;color:#999;text-decoration:underline;cursor:pointer">Skip - I will just explore \uD83C\uDF88</div>';
    ov.appendChild(box);
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) ov.remove(); });
    document.getElementById('tbw-pin-close').addEventListener('click', function () { ov.remove(); });
    var run = function () {
      var v = (document.getElementById('tbw-pin-in').value || '').replace(/\D/g, '');
      var msg = document.getElementById('tbw-pin-msg');
      if (v.length !== 6) { msg.style.color = '#c0392b'; msg.textContent = 'Please enter a valid 6-digit pincode'; return; }
      var ok = CHENNAI_PINS.indexOf(v) > -1;
      try { localStorage.setItem('tbw_pin_chennai', JSON.stringify({ pin: v, ok: ok, at: Date.now() })); } catch (e) {}
      if (ok) {
        msg.style.color = '#1e8e3e';
        msg.innerHTML = '\u2705 Great news! We service <b>' + v + '</b>.<br>Same-day & scheduled setups available in Chennai.';
        document.getElementById('tbw-pin-close').textContent = 'Explore Chennai designs \u2192';
      } else {
        msg.style.color = '#b3541e';
        msg.innerHTML = '\uD83D\uDE14 We are currently unavailable at <b>' + v + '</b>.<br>But you can still explore the website & book anywhere we serve \uD83C\uDF88';
      }
    };
    document.getElementById('tbw-pin-go').addEventListener('click', run);
    document.getElementById('tbw-pin-in').addEventListener('keydown', function (e) { if (e.key === 'Enter') run(); });
    setTimeout(function () { try { document.getElementById('tbw-pin-in').focus(); } catch (e) {} }, 80);
  }

  /* 3. TAG-BASED CATEGORY FILTER (collection pages) */
  var tbwProductData = null;
  var tbwCurrentTag = 'all';
  var tbwCurrentSub = 'all';
  function getCollectionHandle() {
    var m = window.location.pathname.match(/^\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function isCollectionPage() { return !!getCollectionHandle(); }
  function fetchProducts(handle, cb) {
    if (tbwProductData) { cb(tbwProductData); return; }
    var acc = [], page = 1;
    function next() {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/collections/' + handle + '/products.json?limit=250&page=' + page, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            var batch = JSON.parse(xhr.responseText).products || [];
            acc = acc.concat(batch);
            if (batch.length === 250) { page++; return next(); }
            tbwProductData = acc; cb(tbwProductData);
          } catch (e) { cb(acc); }
        } else if (xhr.readyState === 4) { cb(acc); }
      };
      xhr.send();
    }
    next();
  }
  function getProductTags(p) {
    if (Array.isArray(p.tags)) return p.tags.map(function (t) { return String(t).trim(); });
    return (p.tags || '').split(',').map(function (t) { return t.trim(); });
  }
  function buildTagMap(products) {
    var map = {};
    products.forEach(function (p) {
      map[p.handle] = getProductTags(p);
    });
    return map;
  }
  function countByCategory(products) {
    var counts = { all: products.length };
    Object.keys(TAG_CATS).forEach(function (key) {
      counts[key] = products.filter(function (p) {
        var tags = getProductTags(p);
        return TAG_CATS[key].tags.some(function (t) { return tags.indexOf(t) > -1; });
      }).length;
    });
    return counts;
  }
  function renderTagBar(products) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var old = document.getElementById('tbw-tagbar');
    if (old) old.remove();
    var counts = countByCategory(products);
    var bar = document.createElement('div');
    bar.className = 'tbw-tagbar';
    bar.id = 'tbw-tagbar';
    var tabs = [{ key: 'all', label: 'All', count: counts.all }];
    Object.keys(TAG_CATS).forEach(function (key) {
      if (counts[key] > 0) tabs.push({ key: key, label: TAG_CATS[key].label, count: counts[key] });
    });
    bar.innerHTML = tabs.map(function (t) {
      return '<button class="tbw-tagtab' + (t.key === tbwCurrentTag ? ' tbw-tagtab-active' : '') + '" data-tag="' + t.key + '">' +
        t.label + '<span class="tbw-tagcount">' + t.count + '</span></button>';
    }).join('');
    grid.parentNode.insertBefore(bar, grid);
    bar.querySelectorAll('.tbw-tagtab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tbwCurrentTag = btn.getAttribute('data-tag');
        bar.querySelectorAll('.tbw-tagtab').forEach(function (b) { b.classList.remove('tbw-tagtab-active'); });
        btn.classList.add('tbw-tagtab-active');
        applyTagFilter();
      });
    });
  }

  /* 3b. BIRTHDAY SUB-CATEGORY TABS (Kids / Themed / Adult) */
  function renderSubTabs(handle) {
    if (!handle || handle.indexOf('birthday') === -1) return;
    var old = document.getElementById('tbw-subtabs');
    if (old) old.remove();
    var tagbar = document.getElementById('tbw-tagbar');
    if (!tagbar || !tagbar.parentNode) return;
    var bar = document.createElement('div');
    bar.className = 'tbw-subtabs';
    bar.id = 'tbw-subtabs';
    var keys = ['all', 'kids', 'themed', 'adult'];
    bar.innerHTML = keys.map(function (k) {
      return '<button class="tbw-subtab' + (k === tbwCurrentSub ? ' tbw-subtab-active' : '') + '" data-sub="' + k + '">' +
        BIRTHDAY_SUB[k].label + '</button>';
    }).join('');
    tagbar.parentNode.insertBefore(bar, tagbar.nextSibling);
    bar.querySelectorAll('.tbw-subtab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tbwCurrentSub = btn.getAttribute('data-sub');
        bar.querySelectorAll('.tbw-subtab').forEach(function (b) { b.classList.remove('tbw-subtab-active'); });
        btn.classList.add('tbw-subtab-active');
        applyTagFilter();
      });
    });
  }

  /* Build a product card using Dawn's own card classes so it inherits every
     style override (both Dawn CSS and our tbw-desktop.css recolour). */
  function buildCardHTML(p) {
    var imgObj = (p.images && p.images[0]) ? p.images[0] : null;
    var imgSrc = imgObj && imgObj.src ? imgObj.src : '';
    if (imgSrc && imgSrc.indexOf('http') !== 0) imgSrc = 'https:' + imgSrc;
    var imgUrl = imgSrc ? (imgSrc.split('?')[0] + '?width=533&height=533&crop=center') : '';
    var v0 = (p.variants && p.variants[0]) ? p.variants[0] : null;
    var price = v0 && v0.price ? v0.price : '';
    var compareAt = v0 && v0.compare_at_price ? v0.compare_at_price : '';
    var onSale = compareAt && parseFloat(compareAt) > parseFloat(price);
    var safeTitle = String(p.title || '').replace(/"/g, '&quot;');
    var priceBlock = '';
    if (onSale) {
      priceBlock = '<div class="price price--on-sale"><div class="price__container">' +
        '<div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>' +
        '<span class="price-item price-item--regular">Rs. ' + compareAt + '</span></div>' +
        '<div class="price__sale"><span class="visually-hidden visually-hidden--inline">Sale price</span>' +
        '<span class="price-item price-item--sale">Rs. ' + price + '</span></div></div></div>';
    } else if (price) {
      priceBlock = '<div class="price"><div class="price__regular">' +
        '<span class="price-item price-item--regular">Rs. ' + price + '</span></div></div>';
    }
    return '<li class="grid__item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media" style="--ratio-percent:100%;">' +
      '<div class="card__inner color-background-1 gradient ratio" style="--ratio-percent:100%;">' +
      '<div class="card__media"><div class="media media--hover-effect">' +
      '<a href="/products/' + p.handle + '" class="full-unstyled-link" aria-label="' + safeTitle + '">' +
      (imgUrl ? '<img src="' + imgUrl + '" alt="' + safeTitle + '" width="533" height="533" loading="lazy">' : '') +
      '</a></div></div></div>' +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading"><a href="/products/' + p.handle + '" class="full-unstyled-link">' + p.title + '</a></h3>' +
      priceBlock + '</div></div></div></div></div></li>';
  }

  /* Backup of Dawn's original paginated grid + pagination so we can restore
     them when the user clicks "All". */
  var tbwOrigGridHTML = null;
  var tbwOrigExtra = null; /* NodeList of pagination + facets to hide while filtering */

  /* Rewritten: instead of only hiding/showing the 50 DOM cards on the current
     page (which broke because matching products live on other pages and the
     native pagination lost the filter), we now filter the FULL product set
     (already fetched via products.json) and re-render the grid with every
     matching product. Dawn's pagination is hidden while a filter is active
     and restored when "All" is selected again. This makes the category tabs
     AND the birthday sub-tabs work correctly on both /collections/all and
     city-specific birthday collection URLs. */
  function applyTagFilter() {
    if (!tbwProductData) return;
    var city = localStorage.getItem('tbw_city') || 'Bangalore';
    var cityAllowed = CITY_NOTICE_CITIES.indexOf(city) > -1;
    var bouquetAllowed = BOUQUET_CITIES.indexOf(city) > -1;
    var filtered = tbwProductData.filter(function (p) {
      var tags = getProductTags(p);
      var show = true;
      if (tbwCurrentTag !== 'all') {
        show = TAG_CATS[tbwCurrentTag].tags.some(function (t) { return tags.indexOf(t) > -1; });
      }
      if (show && (tags.indexOf('citynoticerequired') > -1 || tags.indexOf('CityNoticeRequired') > -1) && !cityAllowed) {
        show = false;
      }
      if (show && tags.join('|').toLowerCase().indexOf('bouquetcitynotice') > -1 && !bouquetAllowed) {
        show = false;
      }
      /* Sub-category filter (birthday sub-tabs: Kids / Themed / Adult) */
      if (show && tbwCurrentSub !== 'all' && BIRTHDAY_SUB[tbwCurrentSub]) {
        var subTags = BIRTHDAY_SUB[tbwCurrentSub].tags;
        if (subTags.length > 0) {
          show = subTags.some(function (t) { return tags.indexOf(t) > -1; });
        }
      }
      return show;
    });
    var isFiltering = (tbwCurrentTag !== 'all') || (tbwCurrentSub !== 'all');
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    if (isFiltering) {
      if (!tbwOrigGridHTML) {
        tbwOrigGridHTML = grid.innerHTML;
        tbwOrigExtra = document.querySelectorAll('.pagination, .pagination__list, [class*="paginate"], .facets, .facets__wrapper, .facets-container, #tbw-tagbar + .facets');
      }
      if (!filtered.length) {
        grid.innerHTML = '<li class="grid__item" style="grid-column:1/-1;text-align:center;padding:48px 20px;color:#8a7060;font-size:15px;">No products found in this category — try another tab.</li>';
      } else {
        grid.innerHTML = filtered.map(buildCardHTML).join('');
      }
      if (tbwOrigExtra) tbwOrigExtra.forEach(function (el) { el.style.display = 'none'; });
    } else {
      if (tbwOrigGridHTML) grid.innerHTML = tbwOrigGridHTML;
      if (tbwOrigExtra) tbwOrigExtra.forEach(function (el) { el.style.display = ''; });
    }
  }
  window.tbwApplyTagFilter = applyTagFilter;
  function initTagFilter() {
    if (!isCollectionPage()) return;
    var handle = getCollectionHandle();
    if (!handle) return;
    fetchProducts(handle, function (products) {
      if (!products.length) return;
      renderTagBar(products);
      renderSubTabs(handle);
      applyTagFilter();
    });
  }


  /* 4. BOOKING POPUP — REMOVED (delegates to existing #decor-scheduler-overlay)
     The product page already has a complete, working booking flow: an inline
     script wraps window.fetch and, when Dawn's AJAX POST to /cart/add fires,
     it PAUSES the request, opens #decor-scheduler-overlay (date/time picker),
     and replays the add with the date/time line-item properties once the user
     clicks "Confirm & Add to Cart".

     Our earlier wireProductBookButton() added a CAPTURE-phase submit listener
     on the <product-form> ancestor that called stopImmediatePropagation(). That
     prevented Dawn's fetch from ever firing — so the existing scheduler never
     opened and only our (non-functional) #tbw-book-overlay appeared. Users saw
     "2 popups" or a dead popup. We now let Dawn's natural submit run so the
     existing scheduler handles booking. No replacement code is needed. */
  function wireProductBookButton() { /* intentionally empty — see note above */ }

  /* 5. MORE PAGE */
  function renderMorePage() {
    if (window.location.pathname.indexOf('/pages/tbw-more') !== 0) return;
    var main = document.querySelector('.rte, .page__content, #MainContent .rte');
    if (!main) return;
    main.innerHTML = '<h1 style="font-size:32px;font-weight:800;color:#1c1208;margin-bottom:8px;">More</h1>' +
      '<p style="color:#8a7060;margin-bottom:32px;">Account, resources & support.</p>' +
      '<div class="tbw-more-grid">' + MORE_ITEMS.map(function (m) {
        return '<a class="tbw-more-item" href="' + m.href + '"><div class="tbw-more-ic">' + m.ic + '</div>' +
          '<div><div class="tbw-more-lb">' + m.lb + '</div><div class="tbw-more-sub">' + m.sub + '</div></div></a>';
      }).join('') + '</div>';
  }


  /* 6. WHATSAPP FLOAT BUTTON (desktop only) */
  function addWhatsAppFloat() {
    if (document.getElementById('wa-float-btn') || document.querySelector('.tbw-wa-float')) return;
    var btn = document.createElement('a');
    btn.className = 'tbw-wa-float';
    btn.href = 'https://wa.me/' + WA_NUM + '?text=Hi!%20I%20would%20like%20to%20book%20a%20decoration.';
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.setAttribute('aria-label', 'Chat on WhatsApp');
    btn.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="white"><path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.46 0 .1 5.36.1 11.94c0 2.11.55 4.16 1.6 5.97L0 24l6.27-1.64a11.93 11.93 0 0 0 5.77 1.47h.01c6.58 0 11.94-5.36 11.94-11.94 0-3.19-1.24-6.19-3.5-8.45zM12.05 21.8h-.01a9.9 9.9 0 0 1-5.05-1.38l-.36-.22-3.72.98.99-3.63-.24-.37a9.9 9.9 0 0 1-1.52-5.25c0-5.47 4.46-9.93 9.94-9.93 2.66 0 5.16 1.04 7.04 2.92a9.88 9.88 0 0 1 2.92 7.04c0 5.48-4.46 9.93-9.94 9.93zm5.45-7.44c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.47-2.4-1.48-.89-.79-1.49-1.77-1.67-2.07-.17-.3-.02-.46.13-.61.14-.14.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35z"/></svg>';
    document.body.appendChild(btn);
  }

  /* 7. CART BADGE */
  function syncCartBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cl = document.querySelector('.tbw-nav-link[href="/cart"]');
        if (cl && cart.item_count > 0) cl.innerHTML = 'Cart <span class="tbw-tagcount">(' + cart.item_count + ')</span>';
      }).catch(function () {});
  }

  /* 8. SEARCH BAR — live product search */
  var searchPool = null;
  function initSearchInput() {
    var input = document.getElementById('tbw-search-input');
    var results = document.getElementById('tbw-search-results');
    if (!input || !results) return;
    var debounceTimer = null;
    function fetchPool() {
      if (searchPool) return Promise.resolve(searchPool);
      var acc = [], page = 1;
      function next() {
        return fetch('/products.json?limit=250&page=' + page).then(function (r) { return r.json(); })
          .then(function (d) {
            acc = acc.concat(d.products || []);
            if ((d.products || []).length === 250) { page++; return next(); }
            searchPool = acc.map(function (p) {
              return {
                title: p.title || '', handle: p.handle || '',
                img: (p.images && p.images[0]) ? p.images[0].src : '',
                price: p.variants && p.variants[0] ? p.variants[0].price : '',
                tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')
              };
            }).filter(function(p){ return ['Same-Day Express Fee','Outskirts Conveyance Fee'].every(function(pre){ return String(p.title||'').indexOf(pre) !== 0; }); });
            return searchPool;
          });
      }
      return next().catch(function () { return []; });
    }
    function renderResults(query) {
      if (!query || query.length < 2) { results.classList.remove('tbw-show'); return; }
      var q = query.toLowerCase();
      var cityAllowed = CITY_NOTICE_CITIES.indexOf(localStorage.getItem('tbw_city') || '') > -1;
      var bouquetAllowed = BOUQUET_CITIES.indexOf(localStorage.getItem('tbw_city') || '') > -1;
      var matches = (searchPool || []).filter(function (p) {
        var tl = (p.tags || []).map(function (t) { return String(t).toLowerCase().replace(/[^a-z]/g, ''); });
        if (!cityAllowed && tl.indexOf('citynoticerequired') > -1) return false;
        if (!bouquetAllowed && tl.indexOf('bouquetcitynotice') > -1) return false;
        return p.title.toLowerCase().indexOf(q) > -1;
      }).slice(0, 8);
      if (!matches.length) {
        results.innerHTML = '<div class="tbw-search-no-results">No designs found for "' + query + '"</div>';
      } else {
        results.innerHTML = matches.map(function (p) {
          return '<a class="tbw-search-result-item" href="/products/' + p.handle + '">' +
            (p.img ? '<img src="' + p.img + '?width=80&height=80&crop=center" alt="' + p.title + '">' : '') +
            '<div><div class="tbw-sr-title">' + p.title + '</div>' +
            (p.price ? '<div class="tbw-sr-price">Rs. ' + p.price + '</div>' : '') + '</div></a>';
        }).join('');
      }
      results.classList.add('tbw-show');
    }
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (!searchPool) { fetchPool().then(function () { renderResults(input.value); }); }
        else { renderResults(input.value); }
      }, 300);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.tbw-search-wrap')) results.classList.remove('tbw-show');
    });
  }

  /* 10. ROUND CIRCLE CATEGORY NAV — replace broken circle images with icons
     Several .tbw-cn-img <img> tags point at Shopify CDN files that 404
     (naturalWidth 0). We detect those and swap them for a coral-gradient
     circle containing a label-appropriate SVG icon, keeping the layout and
     hover behaviour identical to the working image circles. */
  var TBW_CN_ICONS = {
    'simple': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 4a6 6 0 0 0 0 12c2 0 3-1 3-2.5S12 12 12 10s1-2 1-2"/><circle cx="16" cy="9" r="0.6"/><path d="M10 22V4"/></svg>',
    'for boys': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="4"/><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/></svg>',
    'for girls': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="5"/><path d="M12 14v8M8.5 18.5h7"/></svg>',
    'themed': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 5.6L20 8l-4 4 1 6-5-3-5 3 1-6-4-4 5.6-.4z"/></svg>',
    'romantic': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>',
    'under 2,000': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1.2"/></svg>',
    '2k –4k': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1.2"/></svg>',
    '4k+': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1.2"/></svg>',
    '1st birthday': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/><path d="M9 13s-2 2-2 4 2 3 5 3 5-1 5-3-2-4-2-4"/></svg>',
    'anniversary': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>',
    'baby shower': '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3C8 7 6 9 6 13a6 6 0 0 0 12 0c0-4-2-6-6-10z"/></svg>'
  };
  function fixRoundCircleImages() {
    var imgs = document.querySelectorAll('.tbw-cn-img');
    imgs.forEach(function (img) {
      function replaceBroken() {
        if (img.dataset.tbwFixed) return;
        img.dataset.tbwFixed = '1';
        var item = img.closest('.tbw-cn-item');
        var label = item ? (item.querySelector('.tbw-cn-label') || {}).textContent : '';
        var key = (label || '').toLowerCase().trim();
        var icon = TBW_CN_ICONS[key] || TBW_CN_ICONS['simple'];
        var isPopular = item && item.classList.contains('tbw-cn-item--popular');
        var iconDiv = document.createElement('div');
        iconDiv.className = 'tbw-cn-icon' + (isPopular ? ' tbw-cn-icon--popular' : '');
        iconDiv.innerHTML = icon;
        if (img.parentNode) img.parentNode.replaceChild(iconDiv, img);
      }
      if (img.complete) {
        if (img.naturalWidth === 0) replaceBroken();
      } else {
        img.addEventListener('error', replaceBroken);
        img.addEventListener('load', function () { if (img.naturalWidth === 0) replaceBroken(); });
      }
    });
  }


  /* 9. JOIN US (Vendor Registration) PAGE — content injection */
  function renderJoinPage() {
    if (window.location.pathname.indexOf('/pages/join-us') !== 0) return;
    var main = document.querySelector('.rte, .page__content, #MainContent .rte');
    if (!main) return;
    var benefits = [
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>', title: 'Weekly Orders', desc: 'Get 5-15 decoration orders every week in your city' },
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>', title: 'Flexible Timing', desc: 'Choose morning or evening slots. You set your availability' },
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>', title: 'Cash on Delivery', desc: 'Customers pay you directly after setup. No advance needed' },
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9M5 9v11h14V9M9 20v-5h6v5"/></svg>', title: 'Marketing Support', desc: 'We handle leads, SEO & customer calls. You focus on decor' },
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h6"/></svg>', title: 'Design Catalogue', desc: 'Access 250+ proven designs. Copy, customise, deliver' },
      { ic: '<svg viewBox="0 0 24 24" fill="none" stroke="#e84830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>', title: 'Verified Badge', desc: 'Get a verified vendor profile with reviews & ratings' }
    ];
    main.innerHTML = '<div class="tbw-join-hero"><h1>Become a Decorator Partner</h1>' +
      '<p>Join TheBalloonwala network and start receiving decoration orders in your city. No security deposit. No franchise fee. Just quality leads.</p></div>' +
      '<div class="tbw-join-benefits">' + benefits.map(function (b) {
        return '<div class="tbw-join-benefit"><div class="tbw-jb-ic">' + b.ic + '</div>' +
          '<h3>' + b.title + '</h3><p>' + b.desc + '</p></div>';
      }).join('') + '</div>' +
      '<div class="tbw-join-cta"><h2>Ready to start?</h2>' +
      '<p>Chat with us on WhatsApp and our team will onboard you within 24 hours.</p>' +
      '<a class="tbw-join-btn" href="https://wa.me/' + WA_NUM + '?text=Hi!%20I%20want%20to%20register%20as%20a%20decorator.">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.46 0 .1 5.36.1 11.94c0 2.11.55 4.16 1.6 5.97L0 24l6.27-1.64a11.93 11.93 0 0 0 5.77 1.47h.01c6.58 0 11.94-5.36 11.94-11.94 0-3.19-1.24-6.19-3.5-8.45z"/></svg>' +
      ' Register on WhatsApp</a></div>';
  }

  /* INIT */
  /* City-availability sweep (2026-10): outside the 4 notice cities,
     hide any card/link to a citynoticerequired (premium) product on
     the home page and /search results. Collection grids are already
     filtered inside applyTagFilter(). Uses the live search pool so
     newly tagged products are picked up automatically. */
  function hideCityNoticeCards() {
    var path = window.location.pathname;
    if (path !== '/' && path.indexOf('/search') !== 0) return;
    if (CITY_NOTICE_CITIES.indexOf(localStorage.getItem('tbw_city') || '') > -1
        && BOUQUET_CITIES.indexOf(localStorage.getItem('tbw_city') || '') > -1) return;
    var apply = function (pool) {
      var city = localStorage.getItem('tbw_city') || '';
      var noticeOk = CITY_NOTICE_CITIES.indexOf(city) > -1;
      var bouquetOk = BOUQUET_CITIES.indexOf(city) > -1;
      var hide = {};
      (pool || []).forEach(function (p) {
        var tl = (p.tags || []).map(function (t) { return String(t).toLowerCase().replace(/[^a-z]/g, ''); });
        if (!noticeOk && tl.indexOf('citynoticerequired') > -1) hide[p.handle] = 1;
        if (!bouquetOk && tl.indexOf('bouquetcitynotice') > -1) hide[p.handle] = 1;
      });
      var keys = Object.keys(hide);
      if (!keys.length) return;
      document.querySelectorAll('a[href^="/products/"]').forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/^\/products\/([^\/?#]+)/);
        if (m && hide[m[1]]) {
          var card = a.closest('.grid__item, .card-wrapper, li') || a;
          card.style.display = 'none';
        }
      });
    };
    if (searchPool) { apply(searchPool); return; }
    /* self-contained mini pool (fetchPool is scoped inside initSearchInput) */
    var acc = [], pg = 1;
    var step = function () {
      return fetch('/products.json?limit=250&page=' + pg).then(function (r) { return r.json(); }).then(function (d) {
        var raw = d.products || [];
        raw.forEach(function (p) {
          acc.push({ handle: p.handle || '', tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',') });
        });
        if (raw.length === 250) { pg++; return step(); }
      });
    };
    step().then(function () { apply(acc); }, function () {});
  }

  function init() {
    injectNav();
    maybeShowCityGate();
    initTagFilter();
    wireProductBookButton();
    renderMorePage();
    renderJoinPage();
    addWhatsAppFloat();
    syncCartBadge();
    fixRoundCircleImages();
    try { hideCityNoticeCards(); } catch (e) { /* sweep must never break the page */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(injectNav, 500);
  setTimeout(injectNav, 1500);
  setTimeout(fixRoundCircleImages, 800);
  setTimeout(fixRoundCircleImages, 2500);
})();
